import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Authentication from "../../api/Authentication/Authentication";

const Register = () => {
  const navigate = useNavigate();
  
  // State
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false); // Prevent multiple submissions

  // Handlers
  const handleUsername = async (e) => {
    const value = e.target.value;
    setUsername(value);
    
    try {
      const result = await Authentication.checkUsername(value);
      setIsValid(result.success);
      setError(result.success ? "" : "Username already taken.");
    } catch {
      setError("Error checking username.");
    }
  };

  const handlePassword = (e) => {
    const value = e.target.value;
    setPassword(value);

    if (value.length < 6) {
      setError("Password must be at least 6 characters.");
    } else {
      setError("");
    }
  };

  const submitSignUp = async (e) => {
    e.preventDefault();

    if (!username || !password || !isValid) {
      setError("Please enter valid credentials.");
      return;
    }

    setIsSubmitting(true); // Prevent multiple submissions

    try {
      const result = await Authentication.register(username, password);
      if (result.success) {
        navigate("/verification");
      } else {
        setError("Registration failed.");
      }
    } catch {
      setError("An error occurred. Please try again.");
    } finally {
      setIsSubmitting(false); // Re-enable the button after the request is complete
    }
  };

  return (
    <div className="min-h-[100dvh] flex items-center justify-center bg-gray-900">
      <div className="bg-white/10 backdrop-blur-lg p-8 rounded-2xl shadow-lg max-w-md w-full text-white">
        <div className="flex flex-col items-center">
          <h2 className="text-2xl font-bold">Create Your Account</h2>
        </div>

        {error && <p className="text-red-400 text-center mt-2">{error}</p>}

        <form onSubmit={submitSignUp} className="mt-6">
          <input
            placeholder="Username"
            value={username}
            onChange={handleUsername}
            className="w-full p-3 rounded-lg bg-gray-800 text-white border border-gray-600 focus:border-blue-400 focus:outline-none"
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={handlePassword}
            className="w-full p-3 mt-4 rounded-lg bg-gray-800 text-white border border-gray-600 focus:border-blue-400 focus:outline-none"
            required
          />

          <button
            type="submit"
            disabled={!isValid || password.length < 6 || isSubmitting}
            className="mt-6 w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 rounded-lg transition duration-300 disabled:bg-gray-600"
          >
            {isSubmitting ? "Registering..." : "Join the battle!"}
          </button>
        </form>

        <div className="mt-4 text-center">
          <span className="text-sm">Already have an account?</span>
          <a href="/login" className="ml-1 text-blue-400 hover:underline">
            Log in
          </a>
        </div>
      </div>
    </div>
  );
};

export default Register;